import React from "react";
import classNames from "classnames";

const ProfileJobTitle = ({ className, children, ...props }) => (
  <section className={classNames("profile-job-title", className)} {...props}>
    <div className="profile-organisations">{children}</div>
  </section>
);

export default ProfileJobTitle;
